// extracted by mini-css-extract-plugin
module.exports = {"lockables":"pageWrapper_lockables__FiKWX","content":"pageWrapper_content__IDx3j","main":"pageWrapper_main__dHUNo"};